import { defineMessages, useIntl } from 'react-intl';
import { ROUTES } from 'src/constants/routes.const';
import { getIsValidLabsLanguagePair } from 'src/apps/Labs/labs.const';
import TubeImage from 'src/apps/Labs/tube.png';
import { LinkButton, SvgHelperWrapper } from 'src/components';
import { TrackingApi } from 'src/api';
import { useUserContext } from 'src/context/user';
import { getLanguagePairId } from 'src/utils/language/getLanguagePairId';
import DotsImage from '../../Buddies/dots.svg';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'labs_home_card_title', defaultMessage: 'Memrise Labs' },
  description: {
    id: 'labs_home_card_description',
    defaultMessage:
      'Test out our latest ideas, share your thoughts and shape the future of Memrise.',
  },
  cta: { id: 'labs_home_card_cta', defaultMessage: 'Explore inside' },
});

export const LabsHomeCard = () => {
  const intl = useIntl();
  const { user } = useUserContext();
  const isValidLabsLanguagePair = getIsValidLabsLanguagePair();
  // Show for all cohorts including D0; keep language constraints
  if (!isValidLabsLanguagePair) return null;

  const handleClick = () => {
    /* istanbul ignore next: analytics */
    void TrackingApi.trackUserAction(
      'clicked_home_card',
      'dashboard_home_tab',
      getLanguagePairId(),
      !!user?.isPro,
      { card: 'labs' },
    );
  };

  return (
    <S.Card data-testid="labs-home-card">
      <SvgHelperWrapper Svg={DotsImage} />
      <S.Content>
        <S.TextContent>
          <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
          <S.Description>{intl.formatMessage(msgs.description)}</S.Description>
        </S.TextContent>
        <LinkButton buttonType="secondary" href={ROUTES.labs} onClick={handleClick}>
          {intl.formatMessage(msgs.cta)}
        </LinkButton>
      </S.Content>
      <S.Decoration aria-hidden>
        <S.Image src={TubeImage} aria-label={intl.formatMessage(msgs.title)} />
      </S.Decoration>
    </S.Card>
  );
};

export default LabsHomeCard;
